<template>
  <dropdown-basic
    class="businesses-dropdown"
    :text="business.tradeName"
    :left="true"
    v-if="business"
  >
    <template #dropdown-content>
      <!-- Título -->
      <b-dropdown-item
        class="dropdown-title"
        @click="$router.push({ name: 'businesses' })"
        >Ver todas las marcas</b-dropdown-item
      >

      <b-dropdown-item
        v-for="i in businesses"
        :key="i.id"
        :disabled="i.id === business.id"
        @click="changeBusiness(i)"
        >{{ i.tradeName }}
      </b-dropdown-item>
    </template>
  </dropdown-basic>
</template>

<script>
import { mapGetters } from "vuex";

import { DropdownBasic } from "wize-admin";

export default {
  components: {
    DropdownBasic,
  },
  methods: {
    async changeBusiness(business) {
      this.$store.commit("app/business", business);

      this.$emit('change')

      await this.$store.dispatch("app/loadStartupData");

      if (this.$route.name !== "dashboard") {
        this.$router.push({ name: "dashboard" });
      }
    },
  },
  computed: {
    ...mapGetters({
      business: "app/getBusiness",
      businesses: "app/getBusinesses",
    }),
  },
};
</script>

<style lang="stylus">
@import "../../styles/components/layout/businesses-dropdown.styl"
</style>
